// extracted by mini-css-extract-plugin
export default {"container":"styles__container___CWDMx","iconPadding":"styles__iconPadding___E02vV"};